import { type ReactNode } from 'react';
import { ArrowRight } from 'lucide-react';

type Props = {
  currentPrimary: string;
  currentSecondary: string;
};

const SLOT =
  'flex flex-col gap-xs rounded-lg border border-white/[0.06] bg-surface/40 px-md py-sm';
const LBL = 'text-[10px] uppercase tracking-wide text-text-tertiary';
const VAL = 'truncate text-sm text-text-primary';
const EMPTY = 'truncate text-sm italic text-text-tertiary';

function Slot({ label, value }: { label: string; value: string }): ReactNode {
  return (
    <div className={SLOT}>
      <span className={LBL}>{label}</span>
      <span className={value ? VAL : EMPTY}>
        {value ? `@${value}` : 'No definido'}
      </span>
    </div>
  );
}

export function SwapPreview({
  currentPrimary,
  currentSecondary,
}: Props): ReactNode {
  return (
    <div className="space-y-sm">
      <div className="grid grid-cols-2 gap-sm">
        <Slot label="Principal actual" value={currentPrimary} />
        <Slot label="Personal actual" value={currentSecondary} />
      </div>
      <div className="flex items-center justify-center text-text-tertiary">
        <ArrowRight size={16} />
      </div>
      <div className="grid grid-cols-2 gap-sm">
        <Slot label="Principal nuevo" value={currentSecondary} />
        <Slot label="Personal nuevo" value={currentPrimary} />
      </div>
    </div>
  );
}
